export default __webpack_public_path__ + "static/media/practicum.fae9c0c9.jpg";